import { useRouter } from 'next/router';
import React, { useRef, useState } from 'react';
import { getScreenName } from '../../../../Utils/helper';
import OfferStripHeader from '../../../ArticlePage/OfferStripHeader';
import Search from '../Search';
import { fireEvent } from '../../../../Utils/fireEvent';

function NewHeaderArticle(props) {
  const {
    stage,
    categoryData,
    showInput,
    setShowInput,
    trendingSearchData,
    setShowSearchSectionClass,
    showSearchSectionClass,
    overlayHandler,
    drawerOpen,
    babyCareProduct,
    userType,
  } = props;
  const router = useRouter();
  const carousel = useRef();
  const [selectedItem, setSelectedItem] = useState();
  const onClickHandler = (event) => {
    fireEvent({
      category: 'clicked_search_tab',
      screen_name: getScreenName(),
      position: 'below_strip',
    });
    setShowInput(true);
    setShowSearchSectionClass(event);
    const params = new URLSearchParams(window.location.search);
    params.set('search', 'true');
    router.push(window.location.pathname + '?' + params, '', {
      shallow: true,
      scroll: false,
    });
  };
  // useEffect(() => {
  //     setSelectedItem(carousel?.current?.state?.selectedItem);
  // }, [carousel?.current?.state?.selectedItem]);
  // const data = [
  //     {
  //         img: "https://images.myloapp.in/webP_images/466f3532-a533-4778-a3fc-61154a51a4cb.webp",
  //         name: "How to Establish Good and Effective Baby Sleep Habits?",
  //         views: "4322",
  //         likes: "3556",
  //     },
  //     {
  //         img: "https://images.myloapp.in/webP_images/466f3532-a533-4778-a3fc-61154a51a4cb.webp",
  //         name: "How to Establish Good and Effective Baby Sleep Habits?",
  //         views: "4322",
  //         likes: "3556",
  //     },
  //     {
  //         img: "https://images.myloapp.in/webP_images/466f3532-a533-4778-a3fc-61154a51a4cb.webp",
  //         name: "How to Establish Good and Effective Baby Sleep Habits?",
  //         views: "4322",
  //         likes: "3556",
  //     },
  //     {
  //         img: "https://images.myloapp.in/webP_images/466f3532-a533-4778-a3fc-61154a51a4cb.webp",
  //         name: "How to Establish Good and Effective Baby Sleep Habits?",
  //         views: "4322",
  //         likes: "3556",
  //     },
  // ];
  return (
    <>
      <OfferStripHeader sticky={true} />

      {/* <StickyDiv chips>
                <CategoryChips
                    userType={userType}
                    stage={stage}
                    categoryData={categoryData}
                />
            </StickyDiv> */}

      {/* {!showInput ? (
                <TypicalMobileStyle>
                    <div
                        className="typicalStyleMobile"
                        onClick={onClickHandler}
                    >
                        <TypicalComponent
                            trendingSearchData={trendingSearchData}
                        />
                    </div>
                </TypicalMobileStyle>
            ) : null} */}
      {showInput ? (
        <Search
          setShowSearchSectionClass={setShowSearchSectionClass}
          showSearchSectionClass={showSearchSectionClass}
          overlayHandler={overlayHandler}
          newUX={true}
          drawerOpen={drawerOpen}
          setShowInput={setShowInput}
          showInput={showInput}
          showNewHeader={true}
          trendingSearchData={trendingSearchData}
        />
      ) : null}
      {/* <TrendingTopicsContainer>
                <p className="head">
                    {" "}
                    <img
                        src="https://images.myloapp.in/NestJsUploads/1709729223092-Trending_B.webp"
                        alt=""
                    />
                    Trending Topics
                </p>
                <CarouselCss
                    article={true}
                    pdpTrust={true}
                    color={"transparent"}
                >
                    <Carousel
                        ref={carousel}
                        centerMode={true}
                        centerSlidePercentage={85}
                        showArrows={false}
                        showStatus={false}
                        interval={2000}
                        showThumbs={false}
                        // onChange={(currentIndex, item) => {
                        //     setSelectedItem(currentIndex);
                        // }}
                        swipeable={true}
                        verticalSwipe="standard"
                        // emulateTouch={true}
                        preventMovementUntilSwipeScrollTolerance={true}
                        swipeScrollTolerance={true ? 50 : 5}
                    >
                        {data?.map((element, index) => {
                            return (
                                <TrendingTopicCard key={"trending" + index}>
                                    <img
                                        className="topicImg"
                                        src={element?.img}
                                        alt=""
                                    />
                                    <div className="details">
                                        <p>{element?.name}</p>

                                        <div className="flex">
                                            <div className="flex innerFlex">
                                                <img
                                                    src={
                                                        "https://images.myloapp.in/NestJsUploads/1709729223093-View.webp"
                                                    }
                                                    alt=""
                                                />
                                                <p className="muted">
                                                    {element?.views}
                                                </p>
                                            </div>
                                            <div className=" flex innerFlex">
                                                <img
                                                    src={
                                                        "https://images.myloapp.in/NestJsUploads/1709729223091-Like.webp"
                                                    }
                                                    alt=""
                                                />
                                                <p className="muted">
                                                    {element?.likes}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </TrendingTopicCard>
                            );
                        })}
                    </Carousel>
                </CarouselCss>
            </TrendingTopicsContainer> */}
    </>
  );
}

export default NewHeaderArticle;
